import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="block md:hidden h-full w-full bg-[#014286] flex justify-center items-center py-2">
        <div className="w-full flex items-center justify-center space-x-4 px-2">
          {/* Logo on the Left */}
          <div className="w-[70px]">
            <img src="/assets/logo.png" alt="Logo" className="w-full" />
          </div>

          {/* College Name on the Right - Mobile*/}
          <div className="text-white">
            <div className="relative">
              <h1
                className="absolute top-[-6px] m-0 p-0 left-0 text-[12px]"
                style={{ fontWeight: "900" }}
              >
                SRI
              </h1>
              <div className="w-full">
                <h1
                  className="text-[35px] mt-3 m-0 p-0 uppercase tracking-wide"
                  style={{ fontWeight: "900" }}
                >
                  RAMANUJAR
                </h1>
              </div>
              <div className="w-full">
                <h1 className="w-full block text-[19px] text-justify mt-[-11px] mb-0 font-bold uppercase tracking-wide">
                  ENGINEERING COLLEGE
                </h1>
              </div>
            </div>
            <div className="text-center">
              <p className="text-white text-[10px] text-center m-0 p-0 leading-tight">
                Since 2002, Anna University Affiliated.
              </p>
              <p className="text-white text-[10px] text-center m-0 p-0 leading-tight">
                {" "}
                Kolapakkam, Vandalur, Chennai-600127.
              </p>
              <p className="text-white text-[10px] text-center m-0 p-0 leading-tight">
                <a
                  className="no-underline text-white text-[10px] text-center m-0 p-0 leading-tight"
                  href="https://www.sriramanujar.ac.in"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.sriramanujar.ac.in
                </a>
              </p>
            </div>
          </div>

          <div className="w-[70px]">
            <img className="w-full" alt="" src={"/assets/tnea-1.png"} />
          </div>
        </div>
      </div>

      <div
        className=" hidden md:block !h-full !w-full"
        style={{ backgroundColor: "#014286" }}
      >
        <div className="!w-11/12 !md:gap-1 !mx-auto !flex !flex-col md:!flex-row  !justify-center !items-center">
          <div className="">
            <div className="!w-full md:py-3 py-2 items-center flex flex-col md:flex-row !md:py-5 md:!pl-10">
              <img
                className="!w-[110px]"
                src={"/assets/logo.png"}
                onClick={() => navigate("/")}
                style={{ cursor: "pointer" }}
                alt=""
              />
              <div className="hidden md:block">
                <div style={{ position: "relative" }}>
                  <h3 className="md:!text-4xl md:!w-[100%] leading-10 md:pt-[3%] !text-3xl !text-center pl-[10px] md:!text-left !text-[#f70301] !font-bold text-light uppercase">
                    SRI RAMANUJAR ENGINEERING COLLEGE
                  </h3>
                  {/* <span
                    className="font-bold"
                    style={{
                      position: "absolute",
                      top: "8px",
                      left: "10px",
                      color: "white",
                    }}
                  >
                    {" "}
                    SRI
                  </span> */}
                </div>
                <p className="md:!text-[10px] !text-[55%] !leading-[18px] md:!pl-[4%] !pt-0 !text-center !pb-3 md:!w-[80%] !font-semibold text-light">
                  APPROVED BY AICTE NEW DELHI AND AFFILIATED TO ANNA UNIVERSITY
                  <br /> ISO 9001:2015 CERTIFIED INSTITUTION & ACCREDITED BY
                  NAAC
                </p>
              </div>
              {/* <div className="md:hidden">
        <div style={{ position: "relative" }}>
        <h1 className="text-light uppercase">
            Ramanujar
          </h1>
          <h3 className="md:!text-4xl md:!w-[100%] leading-10 md:pt-[3%] !text-3xl !text-center pl-[10px] md:!text-left !text-[#f70301] !font-bold text-light uppercase">
          Engineering College
          </h3>
          <span
            style={{
              position: "absolute",
              top: "5px",
              left: "10px",
              color: "white",
            }}
          >
            {" "}
            SRI
          </span>
        </div>
        <p className="md:!text-[10px] !text-[55%] !leading-[18px] md:!pl-[4%] !pt-0 !text-center !pb-3 md:!w-[80%] !font-semibold text-light">
          APPROVED BY AICTE NEW DELHI AND AFFILIATED TO ANNA UNIVERSITY
          <br /> ISO 9001:2015 CERTIFIED INSTITUTION & ACCREDITED BY NAAC
        </p>
      </div> */}
            </div>
          </div>

          <div className="">
            <div className="w-[150px] md:pb-0 mx-auto flex justify-content-center align-items-center">
              <img
                className="!w-[110px] object-cover"
                alt=""
                src={"/assets/tnea-1.png"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
